/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Card, Typography } from 'antd';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Container } from '@/primitives/Container';
import { Text } from '@/primitives/Text';

import { PermissionsTable } from './PermissionsTable';

const { Title } = Typography;

interface Permission {
  name: string;
  action: string;
}

interface PermissionGroupData {
  resource: string;
  displayName: string;
  permissions: Permission[];
}

interface PermissionsSectionProps {
  permissionGroups?: PermissionGroupData[];
  permissionsLoading: boolean;
  permissionState: Record<string, boolean>;
  onPermissionToggle: (permissionName: string, enabled: boolean) => void;
}

export function PermissionsSection({
  permissionGroups,
  permissionsLoading,
  permissionState,
  onPermissionToggle,
}: PermissionsSectionProps) {
  const { t } = useMimicTranslation('apiTokens');
  return (
    <Card>
      <Container gap="md">
        <Container gap="xs">
          <Title level={4} style={{ margin: 0, color: '#262626', fontSize: '15px', fontWeight: '600' }}>
            {t('permissionsSection.title')}
          </Title>
          <Text type="subtle" style={{ fontSize: '13px', color: '#8c8c8c' }}>
            {t('permissionsSection.subtitle')}
          </Text>
        </Container>

        {permissionsLoading ? (
          <Text>{t('permissionsSection.loading')}</Text>
        ) : (
          permissionGroups && (
            <PermissionsTable
              permissionGroups={permissionGroups}
              permissionState={permissionState}
              onPermissionToggle={onPermissionToggle}
            />
          )
        )}
      </Container>
    </Card>
  );
}
